import Datepicker from 'vanillajs-datepicker/Datepicker';
import fr from 'vanillajs-datepicker/locales/fr';
import './selectManager';

Object.assign(Datepicker.locales, fr);

(function ($) {
  // Initiate Datepickers
  function initDatePickers() {
    const allPickers = document.getElementsByClassName('dt-picker');
    for (let i = 0; i < allPickers.length; i++) {
      // Grab selectable dates and sku passed by template
      const selectableDates = allPickers.item(i).dataset.dates;
      const sku = allPickers.item(i).dataset.sku;
      let selectableArray = [];
      if (selectableDates.length > 0) {
        selectableArray = selectableDates.split(',').map((dateString) => {
          const dateParser = /(\d{2})\/(\d{2})\/(\d{4})/;
          const match = dateString.match(dateParser);
          return new Date(
            match[3], // year
            match[2] - 1, // monthIndex
            match[1],
          ).toLocaleString('fr-FR');
        });
      }
      const $currentOption = $(allPickers.item(i)).parent(),
        $currentOptionParent = $currentOption.parent(),
        $button = $currentOption.find('.select-button'),
        $nbOfDatesEl = $button.find('span'),
        $atcPanel = $currentOptionParent.find('.options-atc'),
        $backButton = $currentOptionParent.find('.back-cal'),
        $atcOptionsWrapper = $currentOptionParent.find('.products-selected');

      // Initiate the datepicker (btn for Bootstrap classes)
      // Max Number of dates enables multiple selection
      // Disable all dates by default except selectable dates
      const datepicker = new Datepicker(allPickers.item(i), {
        buttonClass: 'btn',
        language: 'fr',
        format: 'dd/mm/yyyy',
        maxNumberOfDates: 10,
        beforeShowDay(date) {
          if (selectableDates.length === 0) return false;
          return selectableArray.includes(date.toLocaleString('fr-FR'));
        },
      });

      // Listen to Custom Event changeDate raised by the calendars
      allPickers.item(i).addEventListener('changeDate', function () {
        const selectedDates = datepicker.getDate();
        $atcOptionsWrapper.empty();
        if (selectedDates.length > 0) {
          $nbOfDatesEl.text(selectedDates.length);
          $button.addClass('on');
          $atcOptionsWrapper.html(
            selectedDates.map((d) => {
              const longDate = d.toLocaleDateString('fr-FR', {
                weekday: 'short',
                year: '2-digit',
                month: 'numeric',
                day: 'numeric',
              });
              const shortDate = d.toLocaleDateString('fr-FR');

              return `
                <li data-date="${shortDate}">
                    <div class="selected-date"><h4>${
                      longDate[0].toUpperCase() + longDate.substring(1)
                    }</h4></div>
                    <div class="selected-quantity">
                        <i class="qt-btn minus"></i>
                        <input class="input-quantity" type="number" min="0" max="10" value="1" name="${shortDate}-quantity">
                        <i class="qt-btn plus"></i>
                    </div>
                 </li>`;
            }),
          );
          bindPlusMinusButtons();
        } else {
          $button.removeClass('on');
        }
      });

      // Bind add to cart button to send sku and quantity to backend and validate products in cart
      const $atcButton = $currentOptionParent.find('.atc-button'),
        $atcMessage = $currentOptionParent.find('.atc-message'),
        $atcWrapper = $currentOptionParent.find('.atc-wrapper');

      $button.click(function () {
        // $currentOption.fadeOut(100);
        $currentOption.removeClass('on');
        $atcPanel.fadeIn(100);
      });
      $backButton.click(function (e) {
        // $currentOption.fadeIn(100, function () {
        //   $(this).addClass('on').hide();
        // });
        $currentOption.addClass('on');
        $atcPanel.fadeOut(100);
        $atcWrapper.show();
        $atcMessage.removeClass('visible');
        e.stopPropagation();
      });

      $atcButton.click(function (e) {
        const options = $atcOptionsWrapper
          .find('li')
          .map(function () {
            const currentDate = $(this).data('date');
            const $inputQuantity = $(this).find('input.input-quantity');
            if ($inputQuantity.length === 0) {
              return false;
            }
            const quantity = parseInt($inputQuantity.val());
            return { date: currentDate, quantity: quantity };
          })
          .get();

        ajaxAddToCartCalendar(
          sku,
          options,
          $atcButton,
          $atcMessage,
          $atcWrapper,
        );
        e.stopPropagation();
      });
    }
  }

  let psStep = 1;
  const $psSelector = $('.products-selector'),
    $psInscription = $psSelector.find('.ps-inscription'),
    $productsOptions = $psSelector.find('.products-options');
  const navBarHeight = $('#wrapper-navbar').innerHeight(),
    windowHeight = $(window).innerHeight(),
    mainSelectorInitialHeight = $psSelector.outerHeight(),
    psOptionsHeight = windowHeight - 64;

  let psInscriptionHeight =
    parseInt($psSelector.css('paddingBottom')) +
    parseInt($psSelector.css('paddingTop')) +
    $productsOptions.outerHeight();

  // Used to store linked products to a tarif element in the page
  let linkedProducts = [];

  // We need to know if products are reserved to intern children and which step of questions we re at
  let questionsStep = $psSelector.data('reserved') === 1 ? 1 : 0;

  $('.ps-intro, .tarifs .ps-option:not([data-form])').click(function () {
    if ($(this).data('products')) {
      // Gets the list of linked products from data attribute and split them. Removes the last , before splitting.
      linkedProducts = $(this)
        .data('products')
        .slice(0, -1)
        .split(',')
        .map(Number);
    } else {
      linkedProducts = [];
    }
    rearrangePsOptions();
    psStep = 2;
    showStep2();
    if (questionsStep !== 0 && questionsStep !== 1) {
      showPsOptions($(this));
    }
  });
  $('.ps-option:not([data-form])').click(function (e) {
    // Second check is to avoid date picker inside an option to raise the click event and close its own option collapse parent
    if (
      questionsStep === 0 &&
      $(e.target).parents('.dt-picker-wrapper').length === 0
    ) {
      showPsOptions($(this));
    }
  });

  // Get product holders linked to forms
  $('.ps-option[data-form]').click(function (e) {
    const formId = $(this).data('form');
    // Forms can be the if of a contact form or a link to a external website' form
    if ('number' === typeof formId) {
      $('.form-overlay').addClass('visible');

      $('.form-holder#form-' + formId).addClass('visible');
    } else {
      e.preventDefault();
      window.open(formId, '_blank');
    }
  });

  function rearrangePsOptions() {
    const $selectorOptions = $productsOptions.find(
      '.ps-option:not(.ps-reserved)',
    );
    $selectorOptions.each(function () {
      if (
        linkedProducts.length !== 0 &&
        linkedProducts.indexOf($(this).data('product-id')) === -1
      ) {
        $(this).addClass('not-visible');
      } else {
        $(this).removeClass('not-visible');
        if (questionsStep !== 1) {
          $(this).show();
        }
      }
    });
    for (let i = linkedProducts.length - 1; i >= 0; i--) {
      $productsOptions
        .find('.ps-option[data-product-id="' + linkedProducts[i] + '"]')
        .prependTo($productsOptions);
    }
  }

  function showPsOptions($currentElement) {
    // If the product option that was clicked is inside the page and not inside product selector component, we need to open the product selector
    if ($currentElement.parents('main').length > 0) {
      psStep = 2;
      showStep2();
      // Set the current element to be the one inside product selector
      const currentProductId = $currentElement.data('product-id');

      $currentElement = $productsOptions.find(
        '.ps-option[data-product-id="' + currentProductId + '"]',
      );
    }
    if (psStep === 2) {
      $psSelector.animate({
        height: windowHeight - navBarHeight,
      });
      const $currentPickerWrapper = $currentElement.find('.dt-picker-wrapper');
      const isVisible = $currentPickerWrapper.hasClass('on');
      $('.dt-picker-wrapper').removeClass('on');
      $('.options-atc').hide();
      if (!isVisible) {
        $currentElement.find('.dt-picker-wrapper').addClass('on');
        // Set picker cells to have same
        // Get width of month element

        const cellWidth = $currentElement
          .find('.datepicker-cell:not(.prev):first')
          .width();
        $currentElement.find('.datepicker-cell').height(cellWidth);
      }
    }
  }
  const reservedButtons = $('.reserved-btn button');

  reservedButtons.click(function () {
    let value = $(this).val();
    const $parent = $(this).parent().parent().parent();
    if (value === '2') {
      $('#ps-reserved-1').addClass('hidden');
      // $('#ps-reserved-2').show().addClass('visible');

      // /!\ quickfix
      // TODO : set way to have only one question if no limit of age for activity
      value = '0';
    }
    if (value === 'no') {
      $parent.find('.option-summary').hide();
      $parent.find('.reserved-error').show();
    }

    if (value === '0') {
      $('.ps-option.ps-reserved').hide();
      $('.ps-option:not(.ps-reserved):not(.not-visible)').show();
      questionsStep = 2;
      // reset inscription wrapper height
      psInscriptionHeight =
        parseInt($psSelector.css('paddingBottom')) +
        parseInt($psSelector.css('paddingTop')) +
        $productsOptions.outerHeight();
      showPsOptions($parent);
    }
  });

  const $questionsReturnButtons = $('.reserved-error button');
  $questionsReturnButtons.click(function () {
    resetQuestions();
  });

  function resetQuestions() {
    const $Questions = $('.ps-reserved');
    const $firstQuestion = $('#ps-reserved-1');
    const $secondQuestion = $('#ps-reserved-2');

    $Questions.find('.option-summary').show();
    $Questions.find('.reserved-error').hide();
    $firstQuestion.show().removeClass('hidden');
    $secondQuestion.hide().removeClass('visible');
  }

  $('.ps-close').click(function () {
    $('.dt-picker-wrapper').removeClass('on');
    psStep = 1;
    $psSelector.animate(
      {
        height: mainSelectorInitialHeight,
      },
      {
        done: function () {
          $psSelector.removeClass('ps-step-2');
          $psInscription.css({ maxHeight: '0px' });
        },
      },
    );
  });

  function showStep2() {
    $psSelector.css({ height: '' });
    $psInscription.css({ maxHeight: `${psInscriptionHeight}px` });
    $productsOptions.css({ maxHeight: `${psOptionsHeight}px` });
    $psSelector.addClass('ps-step-2');
  }

  function bindPlusMinusButtons() {
    const $qtButtons = $('.qt-btn');
    $qtButtons.click(function () {
      const $input = $(this).parent().find('input');
      if ($input.length > 0) {
        let quantity = parseInt($input.val());
        if ($(this).hasClass('minus') && quantity !== 0) {
          $input.val(quantity - 1);
        }
        $(this).hasClass('plus') && $input.val(quantity + 1);
      }
    });
  }

  function displayAtcMessage(
    message,
    cssClass,
    $messageWrapper,
    $atcWrapper,
    keepAtcVisible = false,
  ) {
    $messageWrapper.find('h5').addClass(cssClass).text(message);
    if (!keepAtcVisible) {
      $atcWrapper.hide();
    }
    $messageWrapper.addClass('visible');
  }

  function ajaxAddToCartCalendar(
    sku,
    options,
    $atcButton,
    $atcMessage = null,
    $atcWrapper = null,
  ) {
    let cssClass = '';
    let keepAtcVisible = false;
    let message = '';
    let hasError = false;
    $.ajax({
      type: 'POST',
      url: global_vars.ajaxurl,
      data: {
        action: 'activites_add_products_to_cart',
        sku: sku,
        products: JSON.stringify(options),
      },
      beforeSend: function () {
        $atcButton.block({
          message: null,
          overlayCSS: {
            background: '#fff',
            opacity: 0.6,
          },
        });
      },
      success: function (response) {
        console.log(response);
        // Force Woocommerce to refresh fragments (mini cart)
        $(document.body).trigger('wc_fragment_refresh');
        if (!response.success) {
          message = response.data.message;
          cssClass = 'error';
          hasError = true;
        } else {
          message = response.message;
          cssClass = 'added';
        }
      },
      error: function (xhr, status, error) {
        message = error;
        cssClass = 'error';
        keepAtcVisible = true;
      },
      complete: function () {
        $atcButton.unblock();
        if ($atcWrapper) {
          // Used on calendar product selector buttons
          displayAtcMessage(
            message,
            cssClass,
            $atcMessage,
            $atcWrapper,
            keepAtcVisible,
          );
        } else {
          // Simple animation on ajax add to cart buttons
          $atcButton.addClass(cssClass);
          if (hasError) {
            $atcButton.after(`<div class='text-error'>${message}</div>`);
          }
          setTimeout(() => {
            $atcButton.removeClass(cssClass);
            if (hasError) {
              $('.text-error').remove();
            }
          }, 3000);
        }
      },
    });
  }

  // Binds any add to cart link that should be sent through Ajax
  function bindATCAjaxLinks() {
    const atcAjaxButtons = $('a.atc-ajax, button.atc-ajax');
    atcAjaxButtons.click(function (e) {
      e.preventDefault();
      const sku = $(this).data('product-sku');
      if (sku !== undefined) {
        const options = [{ quantity: 1 }];
        ajaxAddToCartCalendar(sku, options, $(this));
      }
    });
  }

  function initSlider() {
    const $sliderParents = $('.slick-slider');
    if ($sliderParents.length > 0) {
      const slidesToShow = 2;
      const options = {
        infinite: true,
        prevArrow: "<div class='slider-arrow prev-arrow'></div>",
        nextArrow: "<div class='slider-arrow next-arrow'></div>",
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: slidesToShow,
              slidesToScroll: slidesToShow,
            },
          },
        ],
      };
      $sliderParents.each(function () {
        $(this).slick(options);
      });
    }
  }

  /**
   * On some forms, we have specific true false checkboxes generated by acf.
   * So as to style the checked state, we need to bind the click and update the parent class of the input
   * (unfortunately, this specific structure can't be managed with css only)
   */
  function bindTrueFalseCheckboxes() {
    const $trueFalseParents = $('.acf-field-true-false');
    $trueFalseParents.each(function () {
      const $currentParent = $(this);
      const $inputCheckbox = $(this).find('input[type="checkbox"]');
      if ($inputCheckbox.prop('checked')) {
        $currentParent.addClass('checked');
      }

      $inputCheckbox.change(function () {
        // this will contain a reference to the checkbox
        if ($(this).prop('checked')) {
          $currentParent.addClass('checked');
        } else {
          $currentParent.removeClass('checked');
        }
      });
    });
  }

  /**
   * Some pages have a fixed popin (cart, product selector, ...)
   * We need to add a padding bottom to the body to adapt to it
   */
  function setSpaceForFixedPopin() {
    const fixedButton = $('.fixed-atc');
    if (fixedButton.length > 0) {
      const fixedButtonHeight = fixedButton.innerHeight();
      $('body').css('paddingBottom', fixedButtonHeight);
    }
  }

  function closeMainNavOnClick() {
    const $navBarLinks = $("#main-menu.navbar-nav a[href!='#']"),
      $toggler = $('button.navbar-toggler'),
      $collapseNav = $('#navbarNavDropdown');

    $navBarLinks.click(function (e) {
      $collapseNav.removeClass('show');
      $toggler.addClass('collapsed');
    });
  }

  function manageSeeMore() {
    $('span[id^="more-"]').click(function () {
      $(this).toggleClass('visible');
    });
  }

  /**
   * Used to display a popup and shows a youtube video on click on notre projet page
   */
  function bindVideoPopup() {
    const $popupHolder = $('.video-popup');
    if ($popupHolder.length > 0) {
      $popupHolder.YouTubePopUp();
    }
  }

  function closePopups() {
    const $closeButton = $('.close-btn');
    $closeButton.click(function () {
      $('.form-holder').removeClass('visible');
      $('.form-overlay').removeClass('visible');
    });
  }

  manageSeeMore();
  closeMainNavOnClick();
  setSpaceForFixedPopin();
  bindTrueFalseCheckboxes();
  initDatePickers();
  bindATCAjaxLinks();
  initSlider();
  bindVideoPopup();
  closePopups();
})(jQuery);
